var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV4HIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 85,
    viewBox: "0 0 76 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.047 35.831C45.1838 35.831 46.916 34.0987 46.916 31.962C46.916 29.8252 45.1838 28.093 43.047 28.093C40.9102 28.093 39.178 29.8252 39.178 31.962C39.178 34.0987 40.9102 35.831 43.047 35.831Z",
    fill: "#52C8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.411 55.685C34.5478 55.685 36.28 53.9528 36.28 51.816C36.28 49.6792 34.5478 47.947 32.411 47.947C30.2742 47.947 28.542 49.6792 28.542 51.816C28.542 53.9528 30.2742 55.685 32.411 55.685Z",
    fill: "#52C8FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1039 45.733C51.2407 45.733 52.9729 44.0008 52.9729 41.864C52.9729 39.7272 51.2407 37.995 49.1039 37.995C46.9671 37.995 45.2349 39.7272 45.2349 41.864C45.2349 44.0008 46.9671 45.733 49.1039 45.733Z",
    fill: "#52C8FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5919 45.733C28.7287 45.733 30.4609 44.0008 30.4609 41.864C30.4609 39.7272 28.7287 37.995 26.5919 37.995C24.4551 37.995 22.7229 39.7272 22.7229 41.864C22.7229 44.0008 24.4551 45.733 26.5919 45.733Z",
    fill: "#52C8FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0218 55.661C45.1586 55.661 46.8908 53.9288 46.8908 51.792C46.8908 49.6552 45.1586 47.923 43.0218 47.923C40.885 47.923 39.1528 49.6552 39.1528 51.792C39.1528 53.9288 40.885 55.661 43.0218 55.661Z",
    fill: "#52C8FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3858 35.807C34.5226 35.807 36.2548 34.0748 36.2548 31.938C36.2548 29.8012 34.5226 28.069 32.3858 28.069C30.2491 28.069 28.5168 29.8012 28.5168 31.938C28.5168 34.0748 30.2491 35.807 32.3858 35.807Z",
    fill: "#52C8FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9619 19.772C43.0076 19.772 47.0979 15.6817 47.0979 10.636C47.0979 5.59033 43.0076 1.5 37.9619 1.5C32.9163 1.5 28.8259 5.59033 28.8259 10.636C28.8259 15.6817 32.9163 19.772 37.9619 19.772Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9619 17.645C41.8328 17.645 44.9709 14.507 44.9709 10.636C44.9709 6.76505 41.8328 3.62701 37.9619 3.62701C34.0909 3.62701 30.9529 6.76505 30.9529 10.636C30.9529 14.507 34.0909 17.645 37.9619 17.645Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9619 82.878C43.0076 82.878 47.0979 78.7877 47.0979 73.742C47.0979 68.6963 43.0076 64.606 37.9619 64.606C32.9163 64.606 28.8259 68.6963 28.8259 73.742C28.8259 78.7877 32.9163 82.878 37.9619 82.878Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9619 80.751C41.8328 80.751 44.9709 77.613 44.9709 73.742C44.9709 69.8711 41.8328 66.733 37.9619 66.733C34.0909 66.733 30.9529 69.8711 30.9529 73.742C30.9529 77.613 34.0909 80.751 37.9619 80.751Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2881 35.719C70.3338 35.719 74.4241 31.6287 74.4241 26.583C74.4241 21.5373 70.3338 17.447 65.2881 17.447C60.2424 17.447 56.1521 21.5373 56.1521 26.583C56.1521 31.6287 60.2424 35.719 65.2881 35.719Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2881 33.592C69.159 33.592 72.2971 30.454 72.2971 26.583C72.2971 22.7121 69.159 19.574 65.2881 19.574C61.4171 19.574 58.2791 22.7121 58.2791 26.583C58.2791 30.454 61.4171 33.592 65.2881 33.592Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 66.918C15.6817 66.918 19.772 62.8277 19.772 57.782C19.772 52.7363 15.6817 48.646 10.636 48.646C5.59033 48.646 1.5 52.7363 1.5 57.782C1.5 62.8277 5.59033 66.918 10.636 66.918Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 64.791C14.5069 64.791 17.645 61.653 17.645 57.782C17.645 53.911 14.5069 50.773 10.636 50.773C6.76499 50.773 3.62695 53.911 3.62695 57.782C3.62695 61.653 6.76499 64.791 10.636 64.791Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2881 66.918C70.3338 66.918 74.4241 62.8277 74.4241 57.782C74.4241 52.7363 70.3338 48.646 65.2881 48.646C60.2424 48.646 56.1521 52.7363 56.1521 57.782C56.1521 62.8277 60.2424 66.918 65.2881 66.918Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2881 64.791C69.159 64.791 72.2971 61.653 72.2971 57.782C72.2971 53.911 69.159 50.773 65.2881 50.773C61.4171 50.773 58.2791 53.911 58.2791 57.782C58.2791 61.653 61.4171 64.791 65.2881 64.791Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 35.719C15.6817 35.719 19.772 31.6287 19.772 26.583C19.772 21.5373 15.6817 17.447 10.636 17.447C5.59033 17.447 1.5 21.5373 1.5 26.583C1.5 31.6287 5.59033 35.719 10.636 35.719Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 33.592C14.5069 33.592 17.645 30.454 17.645 26.583C17.645 22.7121 14.5069 19.574 10.636 19.574C6.76499 19.574 3.62695 22.7121 3.62695 26.583C3.62695 30.454 6.76499 33.592 10.636 33.592Z",
    stroke: "#004BA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV4HIcon);
export default __webpack_public_path__ + "static/media/v4hIcon.3c9669a7f8b60c03577c2c6d937b6770.svg";
export { ForwardRef as ReactComponent };